import { render } from "./Summary.vue?vue&type=template&id=052f7e9a&scoped=true"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"

import "./Summary.vue?vue&type=style&index=0&id=052f7e9a&lang=css"
import "./Summary.vue?vue&type=style&index=1&id=052f7e9a&scoped=true&lang=css"
import "./Summary.vue?vue&type=style&index=2&id=052f7e9a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052f7e9a"]])

export default __exports__